export { FastshiftDashboard } from "./pages/dashboard-v1/fastshift-dashboard";
export { FastshiftDashboardV2 } from "./pages/dashboard-v2";
export { FastshiftNavigation } from "./common/fastshift-navigation";
export { FastshiftCustomerSelectionPage } from "./pages/customer-selection";
export { FastshiftResourcesPage } from "./pages/resources-page";
export { FastshiftMigrationsManagementPage } from "./pages/migrations-management-page";
export { PageLayout } from "./common/page-layout/page-layout";
export { FastshiftPage } from "./pages/fastshift";
